/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import FormikYourHomeForm from './YourHomeForm';

export default FormikYourHomeForm;
